import * as React from "react";

import "./styles.scss";

// Full-screen branded loading state, styled after the landing page's
// gradient-wordmark treatment (see landingTheme.scss). Used only where the
// app genuinely has to wait before it can render anything (e.g. the Google
// Maps SDK gate in App/index.tsx) — mirrors the static #boot-splash markup
// in public/index.html so the pre-JS and post-JS loading states look like
// one continuous screen instead of two different loaders.
export const BootLoader: React.FC = () => (
  <div className="boot-loader" aria-hidden="true">
    <div className="boot-loader__wordmark">ConnectYid</div>
    <div className="boot-loader__bar" />
  </div>
);
